import React from "react";
import Provider from "./Provider";
import { useLocation } from "react-router-dom";
import { Loader } from "../../services/helper";
import CustomTable from "../../components/CustomTable";

function AllUser() {
  const { allUser, isLoading, handleActive, handleApprove } = Provider();

  const loc = useLocation().state;
  // console.log("ADMIN PROPSPS ::", loc);

  return (
    <>
      {isLoading ? (
        <>
          <Loader />
        </>
      ) : (
        <CustomTable
          TableTitle={`All ${loc?.role} Information`}
          TableData={allUser}
          handleActive={handleActive}
          handleApprove={handleApprove}
          role={loc?.role}
        />
      )}
    </>
  );
}

export default AllUser;
